interface ClassroomConfig {
  ALLOWED_NAMESPACES: string[];
  AVAILABLE_PROGRAMS: {
    id: string;
    name: string;
  }[];
}

export const CLASSROOM_CONFIG = {
  ALLOWED_NAMESPACES: ['hr'],
  AVAILABLE_PROGRAMS: [
    {
      id: '4916c707-f580-4864-841c-d085dcc45b53',
      name: 'Dizajniranje i kreiranje pomoću umjetne inteligencije'
    },
    {
      id: 'b220a0b2-0813-4db7-9add-07383d3ed34a',
      name: 'Designing and building with AI',
    },
    {
      id: '349e64ac-6765-4f08-9cd4-226397b00ffd',
      name: 'Gen Future',
    },
    {
      id: 'b0da5aeb-0067-4e84-8d19-792cd3a94abc',
      name: 'Robotika i automatizirani sustavi'
    },
    {
      id: '95531f73-9524-4418-aed5-1d3ca14dcbd6',
      name: 'BIT Game Development',
    },
    {
      id: '32d0df00-789a-4b94-b647-d16c6d0bb3c5',
      name: 'VidiX'
    }
  ]
};
